import request from "@/utils/request";

// 用户注册
export function register(data) {
  return request({
    url: "/login/register",
    method: "post",
    data,
  });
}

// 用户登录
export function login(data) {
  return request({
    url: "/login/login",
    method: "post",
    data,
  });
}

export function phoneCodeLoginApi(data) {
  return request({
    url: '/login/phoneCodeLogin',
    method: 'post',
    data
  })
}

// 用户信息
export function userInfo() {
  return request({
    url: "/myCenter/userInfo",
    method: "get",
  });
}
// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: "/login/sendSmsCode",
    method: "post",
    data,
  });
}

// 设置头像、昵称是否展示
export function changeNickNameHeadImageStatus(params) {
  return request({
    url: "/myCenter/changeNickNameHeadImageStatus",
    method: "post",
    params,
  });
}

// 发货地址列表
export function myAddressList(params) {
  return request({
    url: "/myAddress/list",
    method: "get",
    params,
  });
}

// 发货地址保存
export function myAddressSave(data) {
  return request({
    url: "/myAddress/save",
    method: "post",
    data,
  });
}

// 发货地址删除
export function myAddressDelete(id) {
  return request({
    url: "/myAddress/delete/" + id,
    method: "post",
  });
}
// 修改性别
export function changeGender(params) {
  return request ({
    url: '/myCenter/changeGender',
    method: 'post',
    params
  })
}

export function checkUserHasPhone() {
  return request({
    url: '/myCenter/checkUserHasPhone',
    method: 'get'
  })
}
